import { generate_layers_with_labels } from './generate-layers-with-labels';
import { generate_layers_without_labels } from './generate-layers-without-labels';
import { mapTheme } from '../definitions/map-theme';
import type { LayerSpecification } from 'maplibre-gl';
import { generate_cluster_layers } from './generate-cluster-layers';
import { generate_area_layers } from './generate-area-layers';

/**
 * generate map layers
 */
export function generateMapLayers(source: string): Array<LayerSpecification> {
    return new Array<LayerSpecification>()
        .concat(
            generate_layers_without_labels(source, mapTheme),
            generate_layers_with_labels(source, mapTheme),
            generate_area_layers(),
            generate_cluster_layers(),
        );
}
